import { atomFamily, DefaultValue } from "recoil";

const getStorageKey = (collapseId: string) => `oc_collapse_${collapseId}`;

const collapseStateEffect =
  (collapseId: string) =>
  ({ setSelf, onSet }: { setSelf: (value: boolean) => void; onSet: (callback: (newValue: boolean | DefaultValue) => void) => void }) => {
    const storageKey = getStorageKey(collapseId);

    // Load from sessionStorage on init
    const savedValue = sessionStorage.getItem(storageKey);
    if (savedValue !== null) {
      setSelf(savedValue === "true");
    }

    // Save to sessionStorage on change
    onSet((newValue) => {
      if (newValue instanceof DefaultValue) {
        sessionStorage.removeItem(storageKey);
      } else {
        sessionStorage.setItem(storageKey, String(newValue));
      }
    });
  };

export const ocCollapseState = atomFamily<boolean, string>({
  key: "ocCollapseState",
  default: true,
  effects: (collapseId) => [collapseStateEffect(collapseId)],
});
